<div fxLayout="column" fxLayoutGap="15px" class="sidebar-container">
  <!-- User Profile Card -->
  <div class="profile-card" fxLayout="column" fxFlex="grow">

    <div fxLayout="row" fxLayoutAlign="center center center" style="margin-top: 20px;">
      <div class="avatar-container">
        <div class="avatar-ring"></div>
        <div *ngIf="imageSource" class="avatar-image">
          <img src={{imageSource}} alt="">
        </div>
        <div *ngIf="!imageSource" class="avatar-default">
          <span class="avatar-initials">{{user.firstName?.charAt(0)}}{{user.lastName?.charAt(0)}}</span>
        </div>
        <div class="avatar-status"></div>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center center" class="user-name">
      <span>{{user.firstName}} {{user.lastName}}</span>
    </div>

    <div class="user-info-section">
      <div class="info-item">
        <mat-icon>person</mat-icon>
        <span>{{ user.roleName === 'Γονέας' ? 'Χρήστης' : user.roleName }}</span>
      </div>

      <div class="info-item">
        <mat-icon>mail</mat-icon>
        <span>{{user.email}}</span>
      </div>

      <div class="info-item">
        <mat-icon>call</mat-icon>
        <span>{{user.telephone}}</span>
      </div>
    </div>

    <div class="divider"></div>

    <div class="action-buttons">
      <button mat-flat-button (click)="showParentSettings()" class="action-btn settings-btn">
        <mat-icon>settings</mat-icon>
        <span>Ρυθμίσεις</span>
      </button>

      <button mat-flat-button (click)="logout()" class="action-btn logout-btn">
        <mat-icon>exit_to_app</mat-icon>
        <span>Αποσύνδεση</span>
      </button>
    </div>

  </div>

  <!-- Navigation Cards -->
  <div (click)="switchToChildConsents()" class="nav-card">
    <div class="nav-card-icon">
      <mat-icon>description</mat-icon>
    </div>
    <div class="nav-card-content">
      <span class="nav-card-title">Διαθέσιμες δηλώσεις</span>
    </div>
    <div *ngIf="notifications && notifications.length > 0" class="nav-card-badge">
      {{notifications.length}}
    </div>
  </div>

  <div (click)="switchToHistoryConsents()" class="nav-card">
    <div class="nav-card-icon">
      <mat-icon>history</mat-icon>
    </div>
    <div class="nav-card-content">
      <span class="nav-card-title">Ιστορικό δηλώσεων</span>
    </div>
  </div>

  <div (click)="switchToMessages()" class="nav-card">
    <div class="nav-card-icon">
      <mat-icon>message</mat-icon>
    </div>
    <div class="nav-card-content">
      <span class="nav-card-title">Τα μηνύματά μου</span>
    </div>
    <div *ngIf="messageTotal > 0" class="nav-card-badge warn">
      {{messageTotal}}
    </div>
  </div>

</div>
